import { render, staticRenderFns } from "./photoList.vue?vue&type=template&id=6965c3ca&scoped=true&"
import script from "./photoList.vue?vue&type=script&lang=js&"
export * from "./photoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965c3ca",
  null
  
)

export default component.exports